import React from "react";
import ReactDOM from "react-dom";
import DeleteEmployeesModal from "../../../app/components/modals/employee/DeleteEmployeesModal";

function renderDeleteMultipleEmployeesModal(props, target) {
  ReactDOM.render(
    <DeleteEmployeesModal {...props} target={target} />,
    document.getElementById(target || "modal-container")
  );
}

export function displayDeleteMultipleEmployeesModal(props, target) {
  renderDeleteMultipleEmployeesModal(props, target);
}
